import { IoClose } from "react-icons/io5";

const ClosableCard = ({ title, onClose, children }) => {
    return (
        <div>

            <div className="content">{children}</div>
            <button className="close-button" onClick={onClose}>
                <IoClose size={20} />
            </button>
        </div>
    );
};


export default ClosableCard;